<!--
    Component: SimplePublication
    This is a  subcomponent of Publication Component.
    Represent a short text publication.
-->
<template>
    <v-card-text>
        {{data.payload.text}}
    </v-card-text>
</template>

<script>
    export default {
        name: "SimplePublication",
        props: ['data'],
    }
</script>

<style scoped>
</style>
